module.exports = __webpack_public_path__ + "img/icon_ourMission.89ee82af.svg";